import { VERTICALS_LIST, SAMPLED_APP_NAMES, PHASES_WHITE_LIST } from './sample-rate-lists';
export var SampleRateManager = /*#__PURE__*/function () {
  function SampleRateManager(enableSampleRateForAppNames) {
    this.enableSampleRateForAppNames = enableSampleRateForAppNames;
  }

  var _proto = SampleRateManager.prototype;

  _proto.shouldSampleAppNameEvent = function shouldSampleAppNameEvent(appName, eventId, name) {
    var _PHASES_WHITE_LIST$na, _VERTICALS_LIST$appNa;

    var isEventAndNameWhiteListed = (_PHASES_WHITE_LIST$na = PHASES_WHITE_LIST[name]) == null ? void 0 : _PHASES_WHITE_LIST$na.includes(eventId);
    var isAppNameInList = SAMPLED_APP_NAMES.includes(appName);

    if (!isAppNameInList || !this.enableSampleRateForAppNames || isEventAndNameWhiteListed) {
      return false;
    }

    var sampledEventIds = (_VERTICALS_LIST$appNa = VERTICALS_LIST[appName]) != null ? _VERTICALS_LIST$appNa : [];
    var isEventIdInSamplingList = sampledEventIds.includes(eventId);
    return this.enableSampleRateForAppNames && isEventIdInSamplingList;
  };

  return SampleRateManager;
}();